// Completeness scoring for a song — drives the ring indicator.
// 6 fields are tracked: title, composer, audio (any variant), PDF, BPM, key.

export const computeCompleteness = (song) => {
  if (!song) return { done: 0, total: 6, missing: [], pct: 0 };
  const checks = [
    { key: "title",    label: "Titre",        ok: !!(song.title && song.title.trim()) },
    { key: "composer", label: "Compositeur",  ok: !!((song.composer || song.artist || "").trim()) },
    { key: "audio",    label: "Audio (Répéte ou Playback)",
      ok: !!(song.audio_repete_filename || song.audio_playback_filename || song.audio_filename) },
    { key: "pdf",      label: "Paroles PDF",  ok: !!song.pdf_filename },
    { key: "bpm",      label: "BPM",          ok: typeof song.bpm === "number" && song.bpm > 0 },
    { key: "key",      label: "Tonalité",     ok: !!(song.key && song.key.trim()) },
  ];
  const done = checks.filter((c) => c.ok).length;
  const missing = checks.filter((c) => !c.ok);
  return { done, total: checks.length, missing, checks, pct: done / checks.length };
};

export const completenessColor = ({ done, total }) => {
  if (done >= total) return "var(--gl-neon)";       // bright green = complete
  if (done >= total - 1) return "var(--gl-gold)";   // gold = almost done
  if (done >= Math.floor(total / 2)) return "#f97316"; // orange
  return "#525252";                                  // neutral gray = mostly empty
};
